import { useGetSolicitudIngreso } from "@/shared/actions/erp";
import { LoaderComponent } from "@/shared/components/ui";
import { useParams } from "react-router-dom"
import EditSolicitudIngreso from "../../shared/editSolicitudIngresos";

export default function EditSolicitudIngresoPage() {
  const { id } = useParams();
  //console.log('id', id)

  const { data, isLoading } = useGetSolicitudIngreso(id!)


  if (isLoading) return <LoaderComponent />
  return (
    <EditSolicitudIngreso
    title="Editar Solicitud de Compra"
    editData={data?.data}
    />
  )
}